<template>
  <TableBody
    v-if="!asBlocks"
    class="gw_table_small table-combos tblcombos"
    style="
      --padding-th: 0 1rem 0 0.5rem;
      --padding-sortable-th: var(--padding-th);
      --padding-td: 0 0.5rem;
      --overflow-y-head: scroll;
      --overflow-y-body-scroller: scroll;
      --min-width-table-inner: 27.5rem;
      --cursor-hover-row: default;
      --simple-body-overflow-x: auto;
      --simple-body-overflow-y: hidden;
      --min-width-td: 4rem;
      --min-width-th: 4rem;
    "
    :isInfinite="false"
    :items="items"
    scrollTrack="large-scroll-track"
    ><template #head_before>
      <TableHead
        :hasSpacer="false"
        :thead="thead"
        class="large-scroll-track"
      >
      </TableHead>
    </template>
    <template #default="{ item, index }">
      <StudyPlayersTableRow
        :thead="thead"
        :item="item"
        :index="index"
        :hasCombos="hasCombos"
        :bettingInfo
      >
      </StudyPlayersTableRow>
    </template>
  </TableBody>
  <div
    v-else
    class="d-flex flex-wrap"
    style="gap: 0.5rem"
    data-tst="players-table_blocks"
  >
    <div
      v-for="(item, index) in items"
      :key="index"
      class="f-column flex-1"
      style=""
    >
      <div
        class="text-small clr-grey mr-auto tab_rounded tab_rounded_no-left"
        style="padding: 0.25rem 0.5rem 0 0.5rem"
      >
        <span class="weight_700">
          {{ getPlayerHtmlPosition(item.position) || '-' }}
          <i
            v-if="item.is_hero"
            class="mdi mdi-crown"
          />
        </span>
        <span class="text-smallest uppercase ml-1 weight_600">
          {{ item.relative_position }}
        </span>
      </div>

      <div
        class="tbl_combos"
        :class="{ tbl_combos_nocombos: !hasCombos }"
      >
        <div class="tbl_combos_box">
          <div
            class="text-smallest clr-grey weight_600"
            :data-tst="`player_ev_unit_${item.is_hero ? '0' : '1'}`"
            v-html="getEvUnitHtml({ ...bettingInfo, player: item.is_hero ? '0' : '1' })"
          ></div>
          <StudyPlayersTableRowBox
            :class="item.ev_css_class"
            :hasArrow="item.total_ev !== null"
          >
            <span
              :data-tst="`player_ev_value_${item.is_hero ? '0' : '1'}`"
              v-html="
                item.total_ev !== null
                  ? getEvHtml({
                      ...bettingInfo,
                      ev: item.total_ev,
                      player: item.is_hero ? '0' : '1',
                    })
                  : '-'
              "
            />
          </StudyPlayersTableRowBox>
        </div>

        <div class="tbl_combos_box">
          <div class="text-smallest clr-grey weight_600">
            {{ thead.equity.name }}
          </div>
          <StudyPlayersTableRowBox
            :class="item.eq_css_class"
            :hasArrow="item.total_eq !== null"
          >
            {{
              item.total_eq !== null
                ? `${numFixedUnit((item.total_eq || 0) * 100, 'eq_total')}%`
                : '-'
            }}
          </StudyPlayersTableRowBox>
        </div>

        <div class="tbl_combos_box">
          <div class="text-smallest clr-grey weight_600">
            {{ thead.eqr.name }}
          </div>
          <StudyPlayersTableRowBox
            :class="item.eqr_css_class"
            :hasArrow="item.total_eqr !== null"
          >
            {{
              item.total_eqr !== null
                ? `${numFixedUnit((item.total_eqr || 0) * 100, 'erq_total')}%`
                : '-'
            }}
          </StudyPlayersTableRowBox>
        </div>

        <div
          v-if="hasCombos"
          class="tbl_combos_box"
        >
          <div class="text-smallest clr-grey weight_600">
            {{ thead.combos.name }}
          </div>
          <StudyPlayersTableRowBox
            :class="item.combos_css_class"
            :hasArrow="item.total_combos !== null"
          >
            {{ item.total_combos !== null ? numFixedUnit(item.total_combos, 'combos') : '-' }}
          </StudyPlayersTableRowBox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableHead from '@/components/DataTables/v2/TableHead'
import TableBody from '@/components/DataTables/v2/TableBody'
import StudyPlayersTableRowBox from '@/components/DataTables/v2/tables/StudyPlayersTable/StudyPlayersTableRowBox'
import StudyPlayersTableRow from '@/components/DataTables/v2/tables/StudyPlayersTable/StudyPlayersTableRow'
import table_mix from '@/components/DataTables/table_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'StudyPlayersTable',
  components: {
    TableHead,
    TableBody,
    StudyPlayersTableRowBox,
    StudyPlayersTableRow,
  },
  mixins: [table_mix, float_mix],
  props: {
    hasCombos: { type: Boolean, default: true },
    players: { default: () => [] },
    asBlocks: Boolean,
    bettingInfo: Object,
  },
  data() {
    return {}
  },
  methods: {
    getCssClasses(currentPlayer) {
      const w = 'td_value_up'
      const l = 'td_value_down'

      const otherPlayers = this.players.filter(p => p.position !== currentPlayer.position)

      const isHighest = {
        ev: otherPlayers.every(p => (currentPlayer.total_ev || 0) > (p.total_ev || 0)),
        eq: otherPlayers.every(p => (currentPlayer.total_eq || 0) > (p.total_eq || 0)),
        eqr: otherPlayers.every(p => (currentPlayer.total_eqr || 0) > (p.total_eqr || 0)),
        combos: otherPlayers.every(p => (currentPlayer.total_combos || 0) > (p.total_combos || 0)),
      }

      return {
        ev_css_class: isHighest.ev ? w : l,
        eq_css_class: isHighest.eq ? w : l,
        eqr_css_class: isHighest.eqr ? w : l,
        combos_css_class: isHighest.combos ? w : l,
      }
    },
  },
  computed: {
    items() {
      const res = this.players.map(player => ({
        ...player,
        ...this.getCssClasses(player),
      }))
      return res
    },
    thead() {
      const maxWidth = '7rem'
      return {
        player: {
          maxWidth: '7.5rem',
          // name: this.$t('table_head.player'),
          reverseSort: true,
          cssClass: 'gw_table_head_cell_sticky',
        },
        ev: {
          maxWidth,
          name: this.$t('table_head.ev'),
        },
        equity: {
          maxWidth,
          name: this.$t('table_head.equity'),
        },
        eqr: {
          maxWidth,
          name: this.$t('table_head.eqr'),
        },
        ...(this.hasCombos
          ? {
              combos: {
                maxWidth,
                name: this.$t('table_head.combos'),
              },
            }
          : {}),
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.tbl_combos {
  // background: var(--clr-black-0);
  // border: var(--clr-black-0) 1px solid;
  border-radius: 0px 4px 4px 4px;
  display: grid;
  overflow: hidden;
  gap: 1px;
  // gap: 2px;
  // gap: 0.25rem;
  grid-template-columns: 1fr 1fr;
  &_nocombos {
    .tbl_combos_box {
      &:nth-child(2) {
        border-radius: 0 0 4px 0;
      }
      &:nth-child(3) {
        border-radius: 0 0 4px 0;
      }
    }
  }
  // margin: 0.25rem 0 0 0;
}
.tbl_combos_box {
  // background: var(--clr-black-2);
  background: var(--clr-black-1-3);
  // background: var(--clr-black-1-1);
  // background: var(--clr-black-1-2);
  // background: var(--clr-black-1);
  // background: var(--clr-black-0-3);
  padding: 0.25rem 0.5rem;
  // border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
}
</style>
